import { render, staticRenderFns } from "./HomeMobile.vue?vue&type=template&id=fdcd05f8&scoped=true"
import script from "./HomeMobile.vue?vue&type=script&lang=js"
export * from "./HomeMobile.vue?vue&type=script&lang=js"
import style0 from "./HomeMobile.vue?vue&type=style&index=0&id=fdcd05f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcd05f8",
  null
  
)

export default component.exports